// src/DocumentIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var DocumentIcon = ({ ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "21",
    height: "22",
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M14.7988 1.1546C14.3683 0.724099 13.6228 1.0181 13.6228 1.6166V5.2811C13.6228 6.8141 14.9248 8.0846 16.5103 8.0846C17.5078 8.0951 18.8938 8.0951 20.0803 8.0951C20.6788 8.0951 20.9938 7.3916 20.5738 6.9716C19.0618 5.4491 16.3528 2.7086 14.7988 1.1546Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M19.7337 9.53309H16.6992C14.2107 9.53309 12.1842 7.50659 12.1842 5.01809V1.98359C12.1842 1.40609 11.7117 0.933594 11.1342 0.933594H6.68224C3.44824 0.933594 0.83374 3.03359 0.83374 6.78209V16.0851C0.83374 19.8336 3.44824 21.9336 6.68224 21.9336H14.9352C18.1692 21.9336 20.7837 19.8336 20.7837 16.0851V10.5831C20.7837 10.0056 20.3112 9.53309 19.7337 9.53309ZM10.2837 17.4711H6.08374C5.65324 17.4711 5.29624 17.1141 5.29624 16.6836C5.29624 16.2531 5.65324 15.8961 6.08374 15.8961H10.2837C10.7142 15.8961 11.0712 16.2531 11.0712 16.6836C11.0712 17.1141 10.7142 17.4711 10.2837 17.4711ZM12.3837 13.2711H6.08374C5.65324 13.2711 5.29624 12.9141 5.29624 12.4836C5.29624 12.0531 5.65324 11.6961 6.08374 11.6961H12.3837C12.8142 11.6961 13.1712 12.0531 13.1712 12.4836C13.1712 12.9141 12.8142 13.2711 12.3837 13.2711Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
var DocumentIcon_default = DocumentIcon;

export {
  DocumentIcon_default
};
